import * as React from 'react';

const NotFoundPage = () => (
    <div>
        <h3>Property Not Found</h3>
        <p>
            We apologize that we were unable to find information for this property. Please check the
            property spelling in the URL.
        </p>
        <p>Thanks for using Tour24!</p>
    </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/property/NotFoundPage.tsx